import { z } from 'zod';
/** Roles a participant administrator may grant within their own participant. */
export const ParticipantRole = z.enum(['participant_admin', 'participant_user']);
export const ParticipantUser = z.object({
    id: z.string(),
    username: z.string(),
    displayName: z.string(),
    role: ParticipantRole,
    provider: z.enum(['local', 'entra']),
    disabled: z.boolean(),
    email: z.string().nullable(),
    emailVerified: z.boolean(),
    createdAt: z.string(),
    updatedAt: z.string(),
});
export const ParticipantUserList = z.object({ items: z.array(ParticipantUser) });
export const Password = z.string().min(12, 'at least 12 characters').max(200);
/**
 * Invite a colleague. With the local provider a password is required; with
 * Entra the username is the sign-in email and the account is linked on first
 * sign-in.
 */
export const ParticipantUserInvite = z
    .object({
    username: z
        .string()
        .min(3)
        .max(120)
        .regex(/^[a-z0-9][a-z0-9._@+-]*$/i, 'letters, digits and . _ @ + - only'),
    displayName: z.string().min(1).max(200),
    role: ParticipantRole,
    password: Password.optional(),
    /** Local accounts only. Without requireEmailVerification the address is recorded as verified. */
    email: z.string().trim().toLowerCase().email().max(254).optional(),
    /** Sends a 24-hour verification link; the user can't sign in until they open it. */
    requireEmailVerification: z.boolean().optional(),
})
    .strict()
    .refine((i) => !i.requireEmailVerification || i.email !== undefined, {
    message: 'an email address is needed to require verification',
    path: ['requireEmailVerification'],
});
export const ParticipantUserUpdate = z
    .object({
    role: ParticipantRole.optional(),
    disabled: z.boolean().optional(),
})
    .strict()
    .refine((u) => u.role !== undefined || u.disabled !== undefined, { message: 'nothing to change' });
export const PasswordChange = z
    .object({
    currentPassword: z.string().min(1),
    newPassword: Password,
})
    .strict();
//# sourceMappingURL=users.js.map